/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrackItMeasurementParameterFilterWithMatchingValueDto } from './TrackItMeasurementParameterFilterWithMatchingValueDto';
import {
    instanceOfTrackItMeasurementParameterFilterWithMatchingValueDto,
    TrackItMeasurementParameterFilterWithMatchingValueDtoFromJSON,
    TrackItMeasurementParameterFilterWithMatchingValueDtoFromJSONTyped,
    TrackItMeasurementParameterFilterWithMatchingValueDtoToJSON,
} from './TrackItMeasurementParameterFilterWithMatchingValueDto';
import type { TrackItMeasurementParameterFilterWithUserValueDto } from './TrackItMeasurementParameterFilterWithUserValueDto';
import {
    instanceOfTrackItMeasurementParameterFilterWithUserValueDto,
    TrackItMeasurementParameterFilterWithUserValueDtoFromJSON,
    TrackItMeasurementParameterFilterWithUserValueDtoFromJSONTyped,
    TrackItMeasurementParameterFilterWithUserValueDtoToJSON,
} from './TrackItMeasurementParameterFilterWithUserValueDto';

/**
 * @type TrackItMeasurementParameterFilterDto
 * 
 * @export
 */
export type TrackItMeasurementParameterFilterDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithMatchingValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItMeasurementParameterFilterWithMatchingValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithUserValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItMeasurementParameterFilterWithUserValueDto;


export function TrackItMeasurementParameterFilterDtoFromJSON(json: any): TrackItMeasurementParameterFilterDto {
    return TrackItMeasurementParameterFilterDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementParameterFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementParameterFilterDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithMatchingValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItMeasurementParameterFilterWithMatchingValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithMatchingValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithUserValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItMeasurementParameterFilterWithUserValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithUserValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of TrackItMeasurementParameterFilterDto exists with '$type=${json['$type']}'`);
    }
}

export function TrackItMeasurementParameterFilterDtoToJSON(value?: TrackItMeasurementParameterFilterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithMatchingValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItMeasurementParameterFilterWithMatchingValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithUserValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItMeasurementParameterFilterWithUserValueDtoToJSON(value);
        default:
            throw new Error(`No variant of TrackItMeasurementParameterFilterDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the TrackItMeasurementParameterFilterDto interface.
 */
export function instanceOfTrackItMeasurementParameterFilterDto(value: any): value is TrackItMeasurementParameterFilterDto {
    if (instanceOfTrackItMeasurementParameterFilterWithMatchingValueDto(value)) return true;
    if (instanceOfTrackItMeasurementParameterFilterWithUserValueDto(value)) return true;
    return false;
}

